import { UploadBtnPkmt } from 'src/components/upload-btn-pkmt';

export default UploadBtnPkmt;
